import React, { useEffect } from 'react'
import { Typography } from 'antd'
import { ModeContext } from '../provider/ModeProvider'
import { useLocation } from 'react-router-dom'
import FundingInitializeForm from './funding/FundingInitializeForm'
import FundingCreateForm from './funding/FundingCreateForm'
import FundingUpdateForm from './funding/FundingUpdateForm'
const { Title } = Typography

const FundingForm: React.FC = () => {
    const { fundingMode, setFundingMode } = ModeContext()
    const modeList = ['funding-create', 'funding-update']
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const id = queryParams.get('id')

    useEffect(() => {
        if (id) {
            setFundingMode('funding-update')
        }
    }, [id])

    return (
        <>
            <Title level={2}>Simulate Funding</Title>
            {!modeList.includes(fundingMode) && <FundingInitializeForm />}
            {fundingMode === 'funding-create' && <FundingCreateForm />}
            {fundingMode === 'funding-update' && <FundingUpdateForm />}
        </>
    )
}

export default FundingForm
